<template>
  <template v-if="isOk">
    <slot />
  </template>
  <template v-else>
    <slot name="fallback" :on-toggle="onToggle" />
  </template>
</template>

<script lang="ts" setup>
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref } from 'vue';

export interface IProps {
  checkIsOk: () => boolean;
}

const props = defineProps<IProps>();

/* State */
const isOk = ref(false);

/* Methods */
const init = async () => {
  if (props.checkIsOk()) {
    isOk.value = true;
  }
};

init();

/* Handlers */
const onToggle = () => {
  if (!props.checkIsOk()) return;

  isOk.value = true;
};
</script>
